import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import { conferenceStatusOptions } from '../../../constants/conferenceStatus';

const ConferenceFilters = ({ filters, setFilters }) => {
  return (
    <div className="mb-6 bg-card border-2 border-border rounded-lg p-6 shadow-elevation-2">
      <h3 className="text-lg font-semibold text-foreground mb-4">Filters</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Input
          placeholder="Search conferences..."
          value={filters?.search}
          onChange={(e) => setFilters({ ...filters, search: e?.target?.value })}
          icon="Search"
        />
        <Select
          value={filters?.status}
          onChange={(value) => setFilters({ ...filters, status: value })}
          placeholder="Any status"
          clearable
          className="min-w-[12rem]"
          options={conferenceStatusOptions()}
        />
        <Select
          value={`${filters?.sortBy}-${filters?.sortOrder}`}
          onChange={(value) => {
            const [sortBy, sortOrder] = String(value)?.split('-');
            setFilters({ ...filters, sortBy, sortOrder });
          }}
          className="min-w-[13rem]"
          options={[
            { value: 'created_at-desc', label: 'Newest first' },
            { value: 'created_at-asc', label: 'Oldest first' },
            { value: 'name-asc', label: 'Name (A–Z)' },
            { value: 'name-desc', label: 'Name (Z–A)' },
            { value: 'startDate-asc', label: 'Start date (earliest)' },
            { value: 'startDate-desc', label: 'Start date (latest)' },
          ]}
        />
      </div>
    </div>
  );
};

export default ConferenceFilters;